import _ from 'lodash';

const QUESTION_TYPE = {
  MULTI_SELECT: 'multiple_select',
  RANGE: 'range',
  SINGLE_SELECT: 'single_select',
};

export default (tasks, templateValues) => {
  const newTasks = [];

  _.forEach(tasks, (task, index) => {
    let {
      range, // eslint-disable-line prefer-const
      questionOptions = [], // eslint-disable-line prefer-const
      ...restTask
    } = task;

    let questionOptionsAttributes = questionOptions;

    if (task.questionType === QUESTION_TYPE.MULTI_SELECT || task.questionType === QUESTION_TYPE.SINGLE_SELECT) {
      questionOptionsAttributes = [];
      const previousTasks = _.get(templateValues, 'tasks', []);

      questionOptionsAttributes = task.questionOptions.map((option) => ({
        ...(option.id && !_.isEmpty(templateValues) && { id: option.id }),
        label: option.label,
        optionType: option.optionType,
      }));
      const previousTask = _.find(previousTasks, (prevTask) => prevTask.id === task.id);

      if (previousTask && !_.isEmpty(previousTask.questionOptions)) {
        previousTask.questionOptions.forEach((oldOption) => {
          if (_.isEmpty(_.find(task.questionOptions, (opt) => opt.id === oldOption.id))) {
            questionOptionsAttributes.push({ id: oldOption.id, _destroy: true });
          }
        });
      }
    }

    if (task.questionType === QUESTION_TYPE.RANGE) {
      questionOptionsAttributes = [];

      if ((task.questionOptions && task.range >= task.questionOptions.length)
      || !task.questionOptions) {
        for (let i = 0; i < task.range; i += 1) {
          let option = { label: (i + 1).toString(10) };

          if (task.questionOptions && task.questionOptions[i]) {
            option = {
              label: task.questionOptions[i].label,
              id: task.questionOptions[i].id,
              disqualify: null,
              qualify: false,
            };
          }
          if (_.isEmpty(templateValues)) {
            option = _.omit(option, ['id']);
          }
          questionOptionsAttributes.push(option);
        }
      }
      if (task.questionOptions && task.range < task.questionOptions.length) {
        questionOptionsAttributes = task.questionOptions.map((opt, i) => {
          if (i < task.range) {
            return ({
              label: opt.label,
              id: opt.id,
            });
          }
          return ({
            id: opt.id,
            _destroy: true,
          });
        });
      }
    }

    if (_.isEmpty(templateValues)) {
      restTask = _.omit(restTask, ['__typename', 'id', 'groupId']);
    }

    newTasks.push({ ...restTask, questionOrder: index, questionOptionsAttributes });
  });

  return newTasks;
};
